import { useModal } from '@ebay/nice-modal-react';
import { Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { buttonTextMessages } from '@ocx-app/modules/localization/button-text.messages';

import { useConfiguration } from '@ocx/data-configuration';
import { Button, Typography, SizingMultiplier } from '@ocx/ui';
import { ModalDrawer } from '@ocx/ui-modals';

import { messages } from './sms-opted-out-warning-popup.messages';
import { createSmsOptInLink } from './sms-opted-out-warning.utils';

type SmsOptInFailedPopupControllerProps = {
  onConfirm?: () => void;
};

export const SmsOptedOutWarningPopupController = ({ onConfirm }: SmsOptInFailedPopupControllerProps) => {
  const { visible, hide, remove } = useModal();
  const { smsOptInKeyword, smsOptInPhoneNumber } = useConfiguration('smsOptedOutWarning');
  const smsOptInLink = createSmsOptInLink(smsOptInKeyword, smsOptInPhoneNumber);

  const onConfirmButtonClick = () => {
    onConfirm?.();
    hide();
  };

  return (
    <ModalDrawer open={visible} onClose={hide} onExited={remove}>
      <Stack spacing={SizingMultiplier.lg} p={SizingMultiplier.lg} pt={SizingMultiplier.xl}>
        <Stack spacing={SizingMultiplier.md}>
          <Typography variant="h5" component="h1">
            <FormattedMessage {...messages['sms-opted-out-warning:popup-title']} />
          </Typography>
          <Typography>
            <FormattedMessage
              {...messages['sms-opted-out-warning:popup-description']}
              values={{ smsOptInPhoneNumber, smsOptInKeyword }}
            />
          </Typography>
        </Stack>
        <Stack spacing={SizingMultiplier.sm}>
          <Button href={smsOptInLink} component="a" target="_system" onClick={onConfirmButtonClick}>
            <FormattedMessage
              {...messages['sms-opted-out-warning:popup-confirm-button-text']}
              values={{ smsOptInPhoneNumber, smsOptInKeyword }}
            />
          </Button>
          <Button onClick={hide} variant="text">
            <FormattedMessage {...buttonTextMessages['button-text:cancel']} />
          </Button>
        </Stack>
      </Stack>
    </ModalDrawer>
  );
};
